import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { RecurringCouponHeaderContainerModel } from '../../../../../../models/aggregates/erp/coupon';

@Injectable({providedIn: 'root'})
export class RecurringCouponHdrService extends BaseApiTemplateService<RecurringCouponHeaderContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'recurring-coupon-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'recurring-coupon-hdrs/backoffice-ep';
    this.httpClient = http;
  }

}
